import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Button from "@material-ui/core/Button/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import { Slide } from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import DialogContent from "@material-ui/core/DialogContent";
import { Close } from "@material-ui/icons";
import DialogActions from "@material-ui/core/DialogActions";
import SectionHeader from "../../../components/UI/SectionHeader";
import Typography from "@material-ui/core/Typography";
import { withRouter } from "react-router-dom";

const styles = (theme) => ({
  paper: {
    width: "100%",
  },
  modalCloseBtn: {
    position: "absolute",
    top: 10,
    right: 10,
  },
  dialogContent: {
    maxHeight: 300,
  },
});

const NoBDRepCodeAlert = (props) => {
  const [open, setOpen] = useState(false);
  const user = useSelector((state) => state.user);
  useEffect(() => {
    const userBdRepCode = user.user.repCodes.find(
      (repCode) => repCode.isSplit === false
    );
    const userHasBdRepCode = userBdRepCode && !!userBdRepCode.bdRepCode;
    setOpen(!user.readingUser && !userHasBdRepCode);
  }, [user.readingUser]);

  const { classes } = props;

  const handleCloseModal = () => {
    setOpen(false);
  };

  const redirectToProfile = (e) => {
    setOpen(false);
    props.history.push(`/Portal/user/repCodes`);
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Slide}
        TransitionProps={{ direction: "up" }}
        onClose={handleCloseModal}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        aria-labelledby="no-rep-code-modal-title"
        maxWidth={"sm"}
        scroll={"paper"}
        classes={{ paper: classes.paper }}
      >
        <DialogTitle id="no-rep-code-modal-title" disableTypography>
          <SectionHeader text={"Notice"} />
          <IconButton
            className={classes.modalCloseBtn}
            aria-label="Close"
            onClick={redirectToProfile}
          >
            <Close color="primary" />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Typography variant={"body2"}>
            There is information missing in your profile. In order to effectively open
            accounts for your clients please fill out and verify your profile data as accurate.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={redirectToProfile}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default withRouter(withStyles(styles)(NoBDRepCodeAlert));



// WEBPACK FOOTER //
// ./src/containers/Notifications/NoBDRepCodeAlert/index.jsx